export default __webpack_public_path__ + "static/media/36I-102718_-15723_0.4428f4d1.jpg";